
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/modulr-payment-terms",
      function () {
        return require("private-next-pages/modulr-payment-terms.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/modulr-payment-terms"])
      });
    }
  